import { CustomerModel, AuctionModel } from "./";

export class RemittanceModel {
    Id: number;
    CustomerId: number;
    AuctionId: number;
    Notes: string;
    VendorPremium: number;
    Paid: boolean;
    DateCreated: Date;

    Vendor: CustomerModel;
    Auction: AuctionModel;
}